
import React from 'react';
import './SubTabBar.css';
import SilverIcon from './SilverIcon';

export interface SubTab<T extends string> {
  id: T;
  label: string;
  icon: React.ComponentProps<typeof SilverIcon>['name'];
  badge?: number;
}

interface Props<T extends string> {
  tabs: SubTab<T>[];
  active: T;
  onChange: (id: T) => void;
}

export default function SubTabBar<T extends string>({ tabs, active, onChange }: Props<T>) {
  return (
    <div className="sub-tab-bar">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`sub-tab${active === tab.id ? ' sub-tab--active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          <SilverIcon name={tab.icon} size={15} />
          <span>{tab.label}</span>
          {tab.badge != null && tab.badge > 0 && (
            <span className="sub-tab__badge">{tab.badge}</span>
          )}
        </button>
      ))}
    </div>
  );
}
